import { createContext } from "react";
import { DISCONNECTED } from "../user/constants/userStatus";

export const CURRENT_USER = createContext(
    { username: "", status: DISCONNECTED }
);
